var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},'v-select',{ ..._vm.$attrs, items: _vm.items },false))
}
var staticRenderFns = []

export { render, staticRenderFns }